const Sentry = require("@sentry/browser");

const host = typeof window !== "undefined" && window.location ? window.location.hostname : undefined;
const isTestCafeProxy = typeof window !== "undefined" && window.location.host === "localhost:1337";

const derivedEnv = host || process.env.SENTRY_ENV || process.env.NODE_ENV || "development";

Sentry.init({
  dsn: "https://ebf7f688d5f34607bfdaf7dd2b455343@o88850.ingest.us.sentry.io/193533",
  // eslint-disable-next-line no-undef
  release: (RELEASE_VERSION && RELEASE_VERSION.trim()) || undefined,
  environment: derivedEnv,
  enabled: !isTestCafeProxy,
  beforeSend(event) {
    if (isTestCafeProxy) {
      return null;
    }
    if (host) {
      event.tags = { ...(event.tags || {}), host };
    }
    return event;
  },
  denyUrls: [/localhost:1337/i]
});

// libraries
window.$ = require("jquery");
window.jQuery = window.$; //boostrap looks for this
require("jquery-ui/ui/widget");
require("jquery-ui/ui/data");
require("jquery-ui/ui/scroll-parent");
require("jquery-ui/ui/widgets/mouse");
require("jquery-ui/ui/widgets/sortable");
window.angular = require("angular");

window.agGrid = require("ag-grid-enterprise/dist/ag-grid-enterprise.min.js");
window.d3 = require("d3-original");
window.d3.force_labels = require("d3-plugins-dist/dist/zjonsson/force-labels/globals/main").default;
window.d3.tip = require("./assets/d3.tip.js")(window.d3);

require("bootstrap5");
// $.fn.tooltip.Constructor.Default.whiteList.table = [];
// $.fn.tooltip.Constructor.Default.whiteList.tr = [];
// $.fn.tooltip.Constructor.Default.whiteList.td = [];
// $.fn.tooltip.Constructor.Default.whiteList.tbody = [];
// $.fn.tooltip.Constructor.Default.whiteList.thead = []
require("@fortawesome/fontawesome-free");

window.Selectize = require("@selectize/selectize");

// angular modules
require("ngprogress");
require("angular-animate");
require("ngclipboard");
require("ui-select");
require("ui-select/dist/select.css");
require("angular-sanitize");
require("angular-ui-router");
require("angular-ui-bootstrap");
require("angular-ui-sortable");
require("angular-file-upload");
require("angular-growl-v2");
require("angular-growl-v2/build/angular-growl.css");
require("angular-mousetrap-service/release/angular-mousetrap-service.min.js");
require("angular-utils-pagination");
require("angular-material");
require("angular-material/angular-material.css");
require("angular-messages");
require("angular-route");
require("angular-filesize-filter");

require("angular-tree-control/context-menu");
require("angular-tree-control/angular-tree-control.js");
require("angular-tree-control/css/tree-control.css");
require("angular-tree-control/css/tree-control-attribute.css");
require("angular-bootstrap-contextmenu");

require("angular-ordinal");
require("@xsites/angular-selectize2");

console.log("vendor.js loaded");
